import { render, staticRenderFns } from "./TrapezoidBgImg.vue?vue&type=template&id=3c3d97e3&scoped=true&"
import script from "./TrapezoidBgImg.vue?vue&type=script&lang=js&"
export * from "./TrapezoidBgImg.vue?vue&type=script&lang=js&"
import style0 from "./TrapezoidBgImg.vue?vue&type=style&index=0&id=3c3d97e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d97e3",
  null
  
)

export default component.exports